import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserForResetPassword } from 'src/app/core/models/user-for-reset-password';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-confirmemail',
    templateUrl: './confirmemail.component.html',
    styleUrls: ['./confirmemail.component.scss'],
    standalone: false
})
export class ConfirmemailComponent implements OnInit, OnDestroy {

  status: 'loading' | 'success' | 'error' = 'loading';
  countdown = 5;

  private countdownSub: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private readonly toastService: AppToastService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    const params = this.activatedRoute.snapshot.queryParams;
    const userEmail = params['userEmail'];
    const code = params['code'];

    if (!userEmail || !code) {
      this.status = 'error';
      return;
    }

    const userForConfirm: UserForResetPassword = { email: userEmail, code: code, password: null, confirmPassword: null };

    this.authService.confirmEmail(userForConfirm).subscribe({
      next: () => {
        this.status = 'success';
        this.toastService.success('Success', 'Email confirmed! You can now log in.');
        this.startCountdown();
      },
      error: () => {
        this.status = 'error';
      },
    });
  }

  private startCountdown() {
    this.countdownSub = interval(1000).pipe(take(5)).subscribe({
      next: (tick) => {
        this.countdown = 4 - tick;
      },
      complete: () => {
        this.router.navigate(['/login']);
      },
    });
  }

  goToLogin() {
    this.countdownSub?.unsubscribe();
    this.router.navigate(['/login']);
  }

  ngOnDestroy() {
    this.countdownSub?.unsubscribe();
  }

}
